import IntercomComponent from '@/components/intercom/intercom';
import useAnalyticsPageViews from '@/hooks/use-analytics-view-page';
import useReceiveInviteCode from '@/hooks/use-receive-invite-code';
import { Flex } from '@cmpsr/components';
import { Outlet, ScrollRestoration } from 'react-router-dom';

export default function Layout(): React.ReactElement {
  useReceiveInviteCode();
  useAnalyticsPageViews();

  return (
    <Flex flexDirection="column" minHeight="100svh" background="primary-default">
      <Outlet />
      <IntercomComponent />
      <ScrollRestoration />
    </Flex>
  );
}
